module.exports = __webpack_public_path__ + "hinted-Montserrat-Italic.fa9e6a84ba3b6db57a22.eot";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-Montserrat-Italic.eot
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-Montserrat-Italic.eot
// module chunks = 1